module.exports = __webpack_public_path__ + "static/ipo2-3cb369a9dab2e6e6ff009f0b5edfa4f4.jpg";